export { InfoModal as default } from "./InfoModal";
